// extracted by mini-css-extract-plugin
export default {"tab_bar":"styles_tab_bar__5KQLq","tab_button":"styles_tab_button__zxA2s"};